import { CompositeLayer } from '@deck.gl/core'
import { IconLayer, TextLayer } from '@deck.gl/layers'

import Supercluster from 'supercluster'

function getIconSize (size) {
  return Math.min(100, size) / 100 + 1
}

function getCount (d) {
  return d.properties.cluster ? d.properties.point_count : 1
}

// NOTE: this layer is not suitable for data coming from MVT tiles, only for geojson or other fully local data
class ShopsClusterLayer extends CompositeLayer {
  shouldUpdateState ({ changeFlags }) {
    return changeFlags.somethingChanged
  }

  updateState ({ props, oldProps, changeFlags }) {
    const rebuildIndex = changeFlags.dataChanged || props.sizeScale !== oldProps.sizeScale

    if (rebuildIndex) {
      const index = new Supercluster({
        maxZoom: 16,
        radius: props.sizeScale,
        map: props => ({
          id: props.id
        }),
        reduce: (acum, props) => {
          acum.id += `-${props.id}`
        }
      })
      index.load(
        props.data.map(d => ({
          geometry: { type: 'Point', coordinates: props.getPosition(d) },
          properties: d.properties || d
        }))
      )
      this.setState({ index })
    }

    const z = Math.floor(this.context.viewport.zoom)
    if (rebuildIndex || z !== this.state.z) {
      this.setState({
        data: this.state.index.getClusters([-180, -85, 180, 85], z),
        z
      })
    }
  }

  getPickingInfo ({ info, mode }) {
    const pickedObject = info.object && info.object.properties ? info.object.properties : info.object
    if (pickedObject) {
      if (pickedObject.cluster && mode !== 'hover') {
        info.objects = this.state.index
          .getLeaves(pickedObject.cluster_id, 25)
      }
    }
    return info
  }

  renderLayers () {
    const { data } = this.state
    return [
      new IconLayer(
        this.getSubLayerProps({
          ...this.props,
          id: 'cluster-icons',
          data,
          getPosition: d => d.geometry.coordinates,
          getSize: d => getIconSize(getCount(d))
        })
      ),
      new TextLayer(
        this.getSubLayerProps({
          id: 'cluster-text',
          data,
          fontFamily: '"Inter", sans-serif',
          getText: d => d.properties.cluster ? String(d.properties.point_count) : ' ',
          getPosition: d => d.geometry.coordinates,
          getSize: 1,
          getPixelOffset: [0, 2],
          sizeScale: this.props.textSizeScale || this.props.sizeScale,
          getColor: this.props.getTextColor || [255, 255, 255, 255]
        })
      )
    ]
  }
}

ShopsClusterLayer.layerName = 'ShopsClusterLayer'
ShopsClusterLayer.defaultProps = {}

export default ShopsClusterLayer
